import { CardContainer } from "@swiggy-private/dls-web-core/dist/components/CardContainer";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";
import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0 auto;
    background-color: ${({ theme }) => theme.colors[theme.colorMode].background_Primary};
    position: relative;
    overflow-x: hidden;
`;

export const BackgroundBanner = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 380px;
    background: linear-gradient(180deg, rgba(19, 98, 84, 1) 4%, rgba(90, 184, 88, 1) 62%);
    border-radius: 0px 0px 16px 16px;
    z-index: 0;
`;

export const ContentWrapper = styled.div`
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: calc(100vw * (350 / 512));

    @media (min-width: 512px) {
        margin-top: 350px;
    }
`;

export const HeaderSection = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.large};
    padding: ${({ theme }) => theme.spacing.xxLarge} ${({ theme }) => theme.spacing.xLarge}
        ${({ theme }) => theme.spacing.large} ${({ theme }) => theme.spacing.xLarge};
    position: relative;
`;

export const LogoWrapper = styled.div`
    width: 187px;
    height: 57px;
`;

export const EarningTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const HeroSection = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xLarge};
    padding: 0 ${({ theme }) => theme.spacing.medium} ${({ theme }) => theme.spacing.xLarge};
    position: relative;
    width: 100%;
    overflow: visible;
`;

export const LeftDecoration = styled.img`
    position: absolute;
    top: 56px;
    left: -78px;
    width: 136px;
    height: 136px;
    pointer-events: none;
`;

export const RightDecoration = styled.img`
    position: absolute;
    top: 56px;
    right: -78px;
    width: 136px;
    height: 136px;
    pointer-events: none;
`;

export const SafetyBadge = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xxSmall};
    padding: ${({ theme }) => theme.spacing.large} ${({ theme }) => theme.spacing.xLarge};
    justify-content: center;
`;

export const GuardIcon = styled.img`
    width: ${({ theme }) => theme.spacing.medium};
    height: ${({ theme }) => theme.spacing.medium};
`;

export const FormContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xLarge};
    padding: 0 ${({ theme }) => theme.spacing.large} ${({ theme }) => theme.spacing.xLarge};
`;

export const InputWrapper = styled.div<{ isOTPInput?: boolean }>`
    width: 100%;
    margin-bottom: ${({ isOTPInput, theme }) => isOTPInput ? `-${theme.spacing.xLarge}` : "0"};
`;

export const TermsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: ${({ theme }) => theme.spacing.xxSmall};
`;

export const StepsSection = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xLarge};
    padding: ${({ theme }) => theme.spacing.xLarge} ${({ theme }) => theme.spacing.large};
    margin-top: ${({ theme }) => theme.spacing.large};
`;

export const SectionHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.medium};
`;

export const UnderlineGraphic = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xxSmall};
`;

export const UnderlineSVG = styled.svg`
    width: 132px;
    height: 4px;
`;

export const MainBannerContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 512px;
    margin: 0 auto;
    right: 0;
    z-index: 0;
    overflow: hidden;
    aspect-ratio: 512 / 380;

    /* Ensure the banner image fills the box without distortion; CDN w+h can skew pixels. */
    & > img {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center top;
    }
`;

export const HeroSectionCardContainer = styled(CardContainer)`
    position: relative;
`;

// @ts-ignore
export const StyledFullWidthButton = styled(FullWidthButton)(({ theme, isDisabled }) => {
    return {
        backgroundColor: isDisabled ? theme.colors[theme.colorMode].background_Disabled : undefined,
    };
});

export * from "./styles.benefits";
export * from "./styles.steps";
